import { Paper, Stack, Typography } from "@mui/material";
import { AccountPurchasedSmsPackageDto } from "../../../api/psc";
import { toJalaliDate } from "../../../utils/date";

// updated
export default function PurchaseHistoryItem(props: {
    purchasedItem: AccountPurchasedSmsPackageDto;
}) {
    return (
        <Paper sx={{ p: 2 }}>
            <Stack spacing={2}>
                <Typography sx={{ mb: 0.5 }}>
                    {props.purchasedItem.smsPackage.name}
                </Typography>

                <Stack direction="row" spacing={2}>
                    <Stack direction="row" spacing={0.5}>
                        <Typography color="text.secondary">قیمت:</Typography>
                        <Typography color="primary">
                            {props.purchasedItem.smsPackage.price}
                        </Typography>
                        <Typography color="text.secondary">تومان</Typography>
                    </Stack>

                    <Stack direction="row" spacing={0.5}>
                        <Typography color="text.secondary">تاریخ:</Typography>
                        <Typography color="primary">
                            {toJalaliDate(props.purchasedItem.purchaseDate)}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
        </Paper>
    );
}
